import { SalesPerformanceFeaturePage } from "..";

/** 销售部绩效页面入口。 */
export function SalesPerformancePage() {
  return <SalesPerformanceFeaturePage />;
}
